import { loadSearchComponents } from '#pplx/frontend/apps/ask/spa/SearchComponentsRouteShared.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const SearchComponentsRoute = Dynamic(loadSearchComponents, {
    critical: true,
});
//# sourceMappingURL=SearchComponentsRoute.js.map